import React, { useContext } from 'react';
import { AdminContext } from '../../../context/admin-context';
import { MemberContext } from '../../../context/member-context';
import Svg from '../icons/svg';

const FormAddComment = ({ provider }) => {
  const admin = useContext(AdminContext);
  const member = useContext(MemberContext);

  return (
    <div>
      <form
        className="d-flex f-row align-items-center f-grow-1 f-shrink-1 p-relative"
        method="post"
        onSubmit={provider.formSubmit}
      >
        {provider.repliesId !== 0 && (
          <div className="replies-cancel color-danger f-row align-items-center c-p" onClick={provider.cancelReplies}>
            <span className="font-size-2 ml-8p">لغو ارسال پاسخ</span>
            <span>
              <Svg name={'multiply'} label={'Cancel replies'} fill={'#ed4956'} width={11} height={11} />
            </span>
          </div>
        )}
        <textarea
          className="input d-flex f-grow-1 plho"
          ref={provider.inputRef}
          placeholder="نظر خود را بنویسید ..."
          disabled={provider.requestSending}
          onClick={provider.handleClickOnInput}
          readOnly={!(admin.auth.value || member.auth.value)}
        />
        <button
          type="submit"
          className="submit-blue-btn"
          disabled={provider.submitDisabled}
          onClick={provider.handleClickOnSubmit}
        >
          ارسال
        </button>
      </form>
    </div>
  );
};

export default FormAddComment;
